import React, {Component} from "react"

import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import Success from "@irati/ui/src/Success"
import {H2, Body} from "@irati/ui/src/Typography"
import Loading from "@irati/ui/src/Loading"
import GenericModal from "@irati/ui/src/GenericModal"

import {StyledDiv} from "../PerksSettings/PerkVisibility/styled/PerksVisibility"
import CategoryList from "./WellbeingCategoryList"

type Props = InjectIntl

interface State {
  showModal: boolean
  allowLoading: boolean
}

class WellbeingContentVisibility extends Component<Props, State> {
  state: State = {
    showModal: false,
    allowLoading: true
  }

  handleSave = () => {
    this.setState({showModal: true})
    setTimeout(() => {
      this.setState({showModal: false})
    }, 3000)
  }

  hideSavedPopUp = () => {
    this.setState({showModal: false})
  }

  render() {
    const {showModal} = this.state
    const {formatMessage} = this.props

    return (
      <>
        <H2>
          <FormattedMessage id="platform.adminNavigation.secondary.wellbeingContentVisibility" />
        </H2>
        <Body marginBottom={5} marginTop={2}>
          <FormattedMessage id="admin.components.wellbeing.headerTwo" />
        </Body>
        <StyledDiv>
          <div className="text-left">
            <Loading>{<CategoryList onSave={this.handleSave} />}</Loading>
          </div>
        </StyledDiv>
        <GenericModal small hideActions show={showModal} onHide={this.hideSavedPopUp}>
          <Success message={formatMessage({id: "admin.components.perkVisibility.success.message"})} />
        </GenericModal>
      </>
    )
  }
}

export default injectIntl(WellbeingContentVisibility)
